import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { HighlightsPanel } from '@/components/HighlightsPanel';

interface MobileHighlightsPanelProps {
  isOpen: boolean;
  onClose: () => void;
  currentSpaceId: string;
}

export const MobileHighlightsPanel = ({ isOpen, onClose, currentSpaceId }: MobileHighlightsPanelProps) => {
  return (
    <Drawer open={isOpen} onOpenChange={onClose}>
      <DrawerContent className="max-h-[90vh] min-h-[50vh]">
        <DrawerHeader className="pb-2 border-b">
          <DrawerTitle className="text-center">Highlights Analysis</DrawerTitle>
          <DrawerDescription className="text-center text-sm">
            View highlighted insights across interviews
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex-1 overflow-y-auto">
          <div className="p-4">
            <HighlightsPanel
              isOpen={true}
              onClose={() => {}}
              currentSpaceId={currentSpaceId}
            />
          </div>
        </div>
        <div className="border-t p-4">
          <Button onClick={onClose} className="w-full">
            Done
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};